<div class="members-list">
  <app-content-header text="Other Contacts"></app-content-header>
  <!-- contact list  -->
  <div *ngIf="activeScreen === 'list'">
    <div
      class="contact-item"
      *ngFor="let contact of this.contactList$ | async; let i = index;"
      (click)="showEditScreen(contact)"
    >
      <div
        class="emergency-contact-label"
        [ngClass]="{'invisible': !contact.isEmergencyContact}"
      >Emergency Contact</div>
      <div
        class="contact-item-detail"
        tabindex="0"
        [ngClass]="{'bg-emergency': contact.isEmergencyContact }"
      >
        <div class="flex-grow-1">
          {{ contact.firstName + ' ' + contact.lastName }}
        </div>
        <div>
          <img
            *ngIf="contact.isEmergencyContact"
            src="/assets/images/ico_emergency-contact.png"
            width="20"
            style="margin-right:1rem;"
          >
          <svg
            width="11px"
            height="18px"
            viewBox="0 0 10 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="01.-Landing-Page"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <path
                d="M9.7284857,7.37567987 L2.15369023,0.255607678 C1.97849445,0.0907960098 1.74462332,0 1.49525303,0 C1.24588274,0 1.01201161,0.0907960098 0.836815832,0.255607678 L0.278984739,0.779831058 C-0.0839998694,1.12142178 -0.0839998694,1.67660426 0.278984739,2.01767465 L6.63972608,7.99668295 L0.27192709,13.9823253 C0.0967313158,14.147137 0,14.3668425 0,14.6011171 C0,14.8356517 0.0967313158,15.0553573 0.27192709,15.220299 L0.829758183,15.7443923 C1.00509234,15.909204 1.23882509,16 1.48819538,16 C1.73756567,16 1.9714368,15.909204 2.14663258,15.7443923 L9.7284857,8.61781612 C9.90409663,8.45248413 10.0005512,8.23173795 10,7.99707319 C10.0005512,7.76149787 9.90409663,7.54088178 9.7284857,7.37567987 Z"
                id="ico_arrow_right"
                fill="#4F758B"
                fill-rule="nonzero"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <div *ngIf="this.emergencyContactIdList.length === 0">
      Add additional contacts such as emergency contacts and people authorized to pick up your Camper. You must have at least one emergency contact.
    </div>

    <div class="pt-3">
      <app-arrow-link-right
        text="+ Add a Contact"
        (click)="showAddScreen()"
      ></app-arrow-link-right>
    </div>

    <ng-container *ngIf="isFirstTime">
      <hr class="bottom-divider" />
      <footer class="footer-action">
        <button
          class="btn btn-danger btn-block"
          [attr.disabled]="this.emergencyContactIdList.length === 0 ? '' : null"
          (click)="onContinue()"
        >Continue</button>
      </footer>
    </ng-container>
  </div>

  <!-- add contact form -->
  <div *ngIf="activeScreen === 'add'">
    <app-contact-details-form
      #newContactForm
      [displaySelectAsEmergency]="false"
      [isContactDetail]="false"
    ></app-contact-details-form>
    <hr class="bottom-divider" />
    <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action">
      <div class="col pr-sm-1">
        <button
          class="btn btn-block btn-outline-danger"
          (click)="onCancel()"
        >Cancel</button>
      </div>
      <div class="col pl-sm-1">
        <button
          class="btn btn-danger btn-block mb-2 mb-sm-0"
          [attr.disabled]="this.newContactForm.getForm().invalid ? '' : null"
          (click)="onAddContact()"
        >Add</button>
      </div>
    </footer>
  </div>

  <!-- edit contact form -->
  <div *ngIf="activeScreen === 'edit'">
    <app-contact-details-form
      #editContactForm
      [inputFormData]="contactToEdit"
      [displaySelectAsEmergency]="true"
      [isContactDetail]="false"
      [isLastEmergency]="this.emergencyContactIdList.length === 1 && contactToEdit.isEmergencyContact"
    ></app-contact-details-form>

    <div
      class="d-flex justify-content-center"
      style="margin-top: 2rem;"
    >
      <div
        class="d-flex align-items-center delete-member"
        (click)="onDeleteContact()"
        (keyup.enter)="onDeleteContact()"
        tabindex="0"
      >
        <img
          src="assets/images/ico_delete-member.png"
          width="20"
          alt="Delete Contact"
        >
        <span
          class="oswald critical ml-2"
          style="font-size: 0.875rem"
        >Delete this Contact</span>
      </div>
    </div>
    <hr class="bottom-divider" />
    <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action">
      <div class="col pr-sm-1">
        <button
          class="btn btn-block btn-outline-danger"
          (click)="onCancel()"
        >Cancel</button>
      </div>
      <div class="col pl-sm-1">
        <button
          class="btn mb-2 mb-sm-0 btn-danger btn-block"
          [attr.disabled]="this.editContactForm.getForm().invalid ? '' : null"
          (click)="onUpdateContact()"
        >Save</button>
      </div>
    </footer>
  </div>
</div>
